/**
 * отложеная загрузка внешней картинки
 */
import {Widget} from "base/assets/js/widget/Widget.js";
export class LazyDownload extends Widget{

	static bDownloading = false;
	_iInterval;

	run() {
		this._iInterval = window.setInterval( ::this.exec, 500 );
	}

	destructor() {
		this._clearInterval();
		super.destructor();
	}

	exec() {

		// пустая очередь - отдыхаем
		if( LazyDownload.bDownloading ) {
			return;
		}

		LazyDownload.bDownloading = true;

		const sId = this.bl().getAttribute( 'data-ri' );
		this.post( '/image/download', { sId } ).then( ( oImage ) => {
			LazyDownload.bDownloading = false;
			this._clearInterval();
			this.bl().outerHTML = oImage.sHtml;
		} );
	}

	_clearInterval() {
		if( this._iInterval ) {
			clearInterval( this._iInterval );
		}
	}
}
